import Vue from 'vue';
import App from './App.vue';
//import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Keycloak from 'keycloak-js';
import { removeVuetifyCalendarError } from '@/utils/shared-functions-vanilla.js'; //, setKeycloakTokens }
//custom tooltip
import VTooltip from 'v-tooltip';
Vue.use(VTooltip);
import 'v-tooltip/dist/v-tooltip.css';

//printing
import VueHtmlToPaper from 'vue-html-to-paper';
Vue.use(VueHtmlToPaper, {
  name: '_blank',
  autoClose: true,
  styles: [
    //'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://www.dvgapp.org/custom-print-styles.css'
  ]
});

require('@/store/subscriber');

Vue.config.productionTip = false;

let initOptions = {
  url: 'https://api.dvgapp.org/auth/',
  realm: 'DVG',
  clientId: 'labhoh-dashboard',
  onLoad: 'login-required',
  scope: 'offline_access'
};

const keycloak = Keycloak(initOptions);
const token = localStorage.getItem('dashboard-dvg-kc-token'); //offline_token
const refreshToken = localStorage.getItem('dashboard-dvg-kc-refresh-token'); //offline_token

if (token === 'undefined' || refreshToken === 'undefined') {
  localStorage.removeItem('dashboard-dvg-kc-token'); //offline_token
  localStorage.removeItem('dashboard-dvg-kc-refresh-token'); //offline_token
  window.location.reload(true);
} else {
  keycloak
    .init({
      //onLoad: initOptions.onLoad,
      onLoad: 'check-sso', //offline_token
      checkLoginIframe: false,
      token: token, //offline_token
      refreshToken: refreshToken, //offline_token,
      pkceMethod: 'S256'
    })
    .then(auth => {
      if (!auth) {
        keycloak.login({ scope: 'offline_access' }); //offline_token
        //keycloak.login()
      } else {
        console.log('Authenticated');
      }

      new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
      }).$mount('#app');

      //vuetify calendar bug error display fix
      removeVuetifyCalendarError();
      setKeycloakTokens(keycloak);
      store.commit('SET_KC_EXPIRED_TOKEN_FN', keycloak.isTokenExpired);
      store.commit('SET_KEYCLOAK_OBJECT', keycloak);

      keycloak.loadUserInfo().then(data => {
        if (keycloak.realmAccess && keycloak.realmAccess.roles && keycloak.realmAccess.roles.length > 0) data.roles = keycloak.realmAccess.roles;
        else data.roles = [];

        store.commit('SET_USER_OBJECT', data);
      });

      console.log(
        'Token not refreshed, valid for ' + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds'
      );

      setInterval(() => {
        keycloak
          .updateToken(50)
          .then(refreshed => {
            if (refreshed) {
              console.log('Token refreshed ' + refreshed);
              setKeycloakTokens(keycloak);
            } else {
              console.log(
                'Token not refreshed, valid for ' +
                  Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) +
                  ' seconds'
              );
            }
          })
          .catch(e => {
            console.log(e);
            console.log('Failed to refresh token');
            window.location.reload(true);
          });
      }, 60000);
    })
    .catch(e => {
      console.log(e);
    });
}

function setKeycloakTokens(keycloak) {
  store.commit('SET_TOKEN', keycloak.token);
  store.commit('SET_REFRESH_TOKEN', keycloak.refreshToken);
  localStorage.setItem('dashboard-dvg-kc-token', keycloak.token); //offline_token
  localStorage.setItem('dashboard-dvg-kc-refresh-token', keycloak.refreshToken); //offline_token
}
